import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";

const SUCCESE = async (data: any) => {
  toast.success(data, {
    position: toast.POSITION.TOP_LEFT,
  });
};
const FAILED = async (data: any) => {
  console.log(data);
  toast.error(data.message, {
    position: toast.POSITION.TOP_LEFT,
  });
};

export const onboardingAddBankDetails: any = createSlice({
  name: "onboardingAddBankDetails",
  initialState: {
    data: [],
    isCompleted: false,
    isSuccess: false,
    isLoading: false,
  },
  reducers: {
    raise_api_call_bank_detail: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_bank_detail: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isCompleted = true;
      // SUCCESE(action.payload.message);
    },
    failure_api_call_bank_detail: (state, action) => {
      state.isLoading = false;
      FAILED(action.payload);
    },
    create_bank_is_success: (state, action) => {
      state.isSuccess = false;
    },
  },
});
export default onboardingAddBankDetails.reducer;
export const {
  raise_api_call_bank_detail,
  success_api_call_bank_detail,
  failure_api_call_bank_detail,
  create_bank_is_success,
} = onboardingAddBankDetails.actions;
